module.exports = __webpack_public_path__ + "static/media/EUROSN.03684c0a.svg";